import React from "react";
import ReactDOM from "react-dom/client"; // Use ReactDOM.createRoot for React 18+
import App from "./App"; // Your main App component
import "./index.css"; // Optional: if you have global styles
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Render the app
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <App />
);


serviceWorkerRegistration.register();


// ✅ Clear old service worker cache (if any)
if (navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let reg of registrations) {
      reg.unregister();
    }
  });
}

// ✅ Force reload if an old version is loaded
window.addEventListener("load", () => {
  if (localStorage.getItem("forceRefresh") !== "true") {
    localStorage.setItem("forceRefresh", "true");
    window.location.reload(true);
  }
});

if ("caches" in window) {
  caches.keys().then((names) => {
    names.forEach((name) => caches.delete(name));
  });
}